export function hash(str) {
    // Implementation of Java's hashCode function
    // Absolutely not cryptographically secure

    let hash: any = 0;
    for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);

        // Convert to 32bit integer
        hash = hash & hash;
    }
    // Convert to a 32-bit unsigned int, then to an uppercase hex string
    hash = (
        '0000000' +
        //@ts-ignore
        parseInt(hash >>> 0, 10) 
            .toString(16)
            .toUpperCase()
    ).slice(-8);

    // Use 00 as a version identifier
    return '00' + hash;
}

export function isNullOrWhiteSpace(string) {
    return typeof string !== 'string' || string.trim().length === 0;
}

export function hexEncode(str) {
    var hex, i;
    var result = '';
    for (i = 0; i < str.length; i++) {
        hex = str.charCodeAt(i).toString(16);
        result += ('000' + hex).slice(-4);
    }
    return result;
};

export function downloadFile(filename: string, content: string | object | Blob, mimeType = 'text/plain') {
    let blob: Blob;

    // If content is already a Blob, use it directly
    if (content instanceof Blob) {
        blob = content;
    } else {
        // Convert string or object to blob
        let stringContent: string;
        let contentType = mimeType;
        if (typeof content === 'object') {
            stringContent = JSON.stringify(content, null, 2);
            contentType = 'application/json';
        } else {
            stringContent = content;
        }
        blob = new Blob([stringContent], { type: contentType });
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
}

export function importFile(callback: (file: File) => void) {
    let input = document.createElement('input');
    input.type = 'file';
    input.setAttribute('multiple', '');

    input.addEventListener('change', (event) => {
        let files = (event.target as HTMLInputElement).files;
        let numOfFiles = files?.length || 0;

        for (let i = 0; i < numOfFiles; i++) {
            const file = files?.item(i);
            if (file) {
                callback(file);
            }
        }
    });

    input.click();
}